import {IGameFilterDefinition} from '../interfaces/game-filter-definition.interface';
import {GameInfo} from '../../games/game-info';
import {Check} from "@sparkware/app-utils";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class GameGroupFilter implements IGameFilterDefinition {
  constructor(public readonly id: string,
              private readonly _gameGroupName: string | string[] ) {
  }

  applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
    if(Check.isArray(this._gameGroupName)) {
      for(let i = 0; i < this._gameGroupName.length;i++){
        if (this._gameGroupName[i] === gameInfo.gameGroup){
          return ApplyGameFilterResult.IncludeGame;
        }
      }
      return ApplyGameFilterResult.ExcludeGame;
    }

    if(gameInfo.gameGroup === this._gameGroupName) {
      return ApplyGameFilterResult.IncludeGame;
    }
    return ApplyGameFilterResult.ExcludeGame;
  }
}
